import { __assign } from "tslib";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "@mui/material";
import { useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import { ShareCreateProvider } from "../../../hooks/context";
import CreateShareModal from "./CreateShareModal";
var CreateSharesButton = function (_a) {
    var _b;
    var object = _a.object, _c = _a.shareType, shareType = _c === void 0 ? "email" : _c, ButtonProps = _a.ButtonProps, onClose = _a.onClose, onDone = _a.onDone;
    var _d = useState(false), open = _d[0], setOpen = _d[1];
    var handleClose = function () {
        setOpen(false);
        onClose();
    };
    return (_jsxs(_Fragment, { children: [_jsx(Button, __assign({ variant: "text" }, ButtonProps, { startIcon: _jsx(AddIcon, { fontSize: "small" }), "data-testid": "New-Share-Btn", onClick: function () { return setOpen(true); }, children: (ButtonProps === null || ButtonProps === void 0 ? void 0 : ButtonProps.children) || "Share via Email" })), _jsx(ShareCreateProvider, { contentType: (_b = object === null || object === void 0 ? void 0 : object.type) !== null && _b !== void 0 ? _b : "file", shareType: shareType, children: _jsx(CreateShareModal, { object: object, open: open, onClose: handleClose, onDone: onDone }) })] }));
};
export default CreateSharesButton;
